export default "__VITE_ASSET__7143cf04__"